//export const API_BASE_URL= "http://localhost:5000/api/v1"
export const API_BASE_URL= "https://backend.streamcreate.com/api/v1"

export const STRIPE_PUBLISH_KEY = "pk_live_51PbPNiBNNKHFPEtCh4d7mVgcp4u7hTU796V12ZUZUjOBX1UFRHmfGm3iZIH8KKZSoYAYnNGJ0fWwyHNcpPAMxczR00KnBX0clW"
//export const STRIPE_PUBLISH_KEY = "pk_test_51PbPNiBNNKHFPEtCvWgh6AqopesYk6bgfPWZ3DmNerCsJHvdVmien57UyKPnA8IrW5K0CER15yB75ltbOgZnfPaK00telArwo8"
